import axios from 'axios';
import { getAuthToken, getAuthHeader } from './authService';

const API_URL = `${process.env.REACT_APP_SERVER_URL}/api/events/`;

export const addEvent = async (data: any) => {

    // Get the auth token
    const authToken = getAuthToken();
    // Set up the Authorization header with the Bearer token
    const headers = {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': "multipart/form-data",
    };
    try {
        const response = await axios.post(`${API_URL}`, data, { headers });
        if (response.data) {

        }
        return response.data;
    } catch (error: any) {
        console.log(error.message);
        // throw error;
        return null;
    }
};

export const getEvents = async () => {

    // Set up the Authorization header with the Bearer token
    const headers = getAuthHeader();
    try {
        const response = await axios.get(`${API_URL}`, { headers });
        if (response.data) {
            // Save token in local storage or cookie
        }
        return response.data;
    } catch (error: any) {
        console.log(error.message);
        // throw error;
        return [];
    }
};

export const getEvent = async (id: string) => {

    // Set up the Authorization header with the Bearer token
    const headers = getAuthHeader();
    try {
        const response = await axios.get(`${API_URL}${id}`, { headers });
        if (response.data) {
            // Save token in local storage or cookie
        }
        return response.data;
    } catch (error: any) {
        console.log(error.message);
        // throw error;
        return [];
    }
};
export const updateEventMeta = async (eventId: string, meta: Record<string, any>) => {
    const headers = {
        'Authorization': `Bearer ${getAuthToken()}`,
        'Content-Type': 'application/json',
    };
    try {
        const response = await axios.patch(`${API_URL}${eventId}/meta`, { meta }, { headers });
        return response.data;
    } catch (error: any) {
        console.log(error.message);
        throw error;
    }
};

export const uploadEventPromoBanner = async (
    eventId: string,
    slot: number,
    file: File,
    label?: string
): Promise<any> => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('slot', String(slot));
    if (label && label.trim()) {
        formData.append('label', label.trim());
    }
    const headers = {
        Authorization: `Bearer ${getAuthToken()}`,
    };
    try {
        const response = await axios.post(`${API_URL}${eventId}/promo-banners`, formData, { headers });
        return response.data;
    } catch (error: any) {
        const msg = error.response?.data?.message || error.message;
        throw new Error(msg);
    }
};

export const deleteEventPromoBanner = async (eventId: string, slot: number): Promise<any> => {
    const headers = getAuthHeader();
    try {
        const response = await axios.delete(`${API_URL}${eventId}/promo-banners/${slot}`, { headers });
        return response.data;
    } catch (error: any) {
        const msg = error.response?.data?.message || error.message;
        throw new Error(msg);
    }
};

export const updateEvent = async (data: any) => {

    // Get the auth token
    const authToken = getAuthToken();
    // Set up the Authorization header with the Bearer token
    const headers = {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': "multipart/form-data",
    };
    try {
        const response = await axios.put(`${API_URL}${data.id}`, data, { headers });
        if (response.data) {
            console.log('updated data', response.data);
        }
        return response.data;
    } catch (error: any) {
        console.log(error.message);
        // throw error;
        return null;
    }
};
export const deleteEvent = async (id: string) => {

    // Set up the Authorization header with the Bearer token
    const headers = getAuthHeader();
    try {
        const response = await axios.delete(`${API_URL}${id}`, { headers });
        if (response.data) {
            // Save token in local storage or cookie
        }
        return response.data;
    } catch (error: any) {
        console.log(error.message);
        // throw error;
        return [];
    }
};

export const getEventProducts = async (eventId: string) => {

    // Set up the Authorization header with the Bearer token
    const headers = getAuthHeader();
    try {
        const response = await axios.get(`${API_URL}${eventId}/products`, { headers });
        if (response.data) {
            // Save token in local storage or cookie
        }
        return response.data;
    } catch (error: any) {
        console.log(error.message);
        // throw error;
        return [];
    }
};

export const addEventProduct = async (eventId: string, data: any) => {

    // Get the auth token
    const authToken = getAuthToken();
    // Set up the Authorization header with the Bearer token
    const headers = {
        'Authorization': `Bearer ${authToken}`,
        // 'Content-Type': "multipart/form-data",
    };
    try {
        const response = await axios.post(`${API_URL}${eventId}/products`, data, { headers });
        if (response.data) {

        }
        return response.data;
    } catch (error: any) {
        console.log(error.message);
        // throw error;
        return null;
    }
};

export const updateEventProduct = async (eventId: string, data: any) => {

    // Get the auth token
    const authToken = getAuthToken();
    // Set up the Authorization header with the Bearer token
    const headers = {
        'Authorization': `Bearer ${authToken}`,
        // 'Content-Type': "multipart/form-data",
    };
    try {
        const response = await axios.put(`${API_URL}${eventId}/products/${data.id}`, data, { headers });
        if (response.data) {
            console.log('updated data', response.data);
        }
        return response.data;
    } catch (error: any) {
        console.log(error.message);
        // throw error;
        return null;
    }
};

export const getEventProduct = async (eventId: string, id: string) => {

    // Set up the Authorization header with the Bearer token
    const headers = getAuthHeader();
    try {
        const response = await axios.get(`${API_URL}${eventId}/products/${id}`, { headers });
        if (response.data) {
            // Save token in local storage or cookie
        }
        return response.data;
    } catch (error: any) {
        console.log(error.message);
        // throw error;
        return [];
    }
};